export default __webpack_public_path__ + "static/media/pr.8885546e.svg";